import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-checked", "disabled", "aria-disabled"]
const _hoisted_2 = { class: "dropdown-item-after" }

import { useDropdownItem } from '@components/RcDropdown/useDropdownItem';
import { RcIcon } from '@components/RcIcon';


export default /*@__PURE__*/_defineComponent({
  __name: 'RcDropdownItemRadio',
  props: { checked: Boolean, disabled: Boolean },
  emits: ['click'],
  setup(__props, { emit: __emit }) {

/**
 * An item for a dropdown menu that is one choice of several, marked with a checkmark when it is the
 * chosen one. It stays open, so the menu shows the choice made. Used in conjunction with RcDropdown.
 */
const props = __props;
const emits = __emit;

const {
  handleKeydown, handleActivate, scrollIntoView, handleMouseenter
} = useDropdownItem();

const handleClick = (e: MouseEvent) => {
  if (!props.disabled) {
    emits('click', e);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "dropdown-menu-item": "",
    tabindex: "-1",
    role: "menuitemradio",
    "aria-checked": __props.checked,
    disabled: __props.disabled || null,
    "aria-disabled": __props.disabled || false,
    onClick: _withModifiers(handleClick, ["stop"]),
    onKeydown: [
      _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_unref(handleActivate) && _unref(handleActivate)(...args)), ["enter","space"])),
      _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_unref(handleKeydown) && _unref(handleKeydown)(...args)), ["prevent","stop"]), ["up","down"]))
    ],
    onMousedown: _withModifiers(() => {/* As RcDropdownItem: a click doesn't take the focus */}, ["prevent"]),
    onFocusin: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(scrollIntoView) && _unref(scrollIntoView)(...args))),
    onMouseenter: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(handleMouseenter) && _unref(handleMouseenter)(...args)))
  }, [
    _renderSlot(_ctx.$slots, "before"),
    _cache[4] || (_cache[4] = _createTextVNode()),
    _renderSlot(_ctx.$slots, "default"),
    _cache[5] || (_cache[5] = _createTextVNode()),
    _createElementVNode("span", _hoisted_2, [
      (__props.checked)
        ? (_openBlock(), _createBlock(_unref(RcIcon), {
            key: 0,
            type: "checkmark",
            size: "inherit"
          }))
        : _createCommentVNode("", true)
    ])
  ], 40, _hoisted_1))
}
}

})